import { render, staticRenderFns } from "./UnassignedServiceRequest.vue?vue&type=template&id=d42b6ee2&scoped=true&"
import script from "./UnassignedServiceRequest.vue?vue&type=script&lang=js&"
export * from "./UnassignedServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./UnassignedServiceRequest.vue?vue&type=style&index=0&id=d42b6ee2&prod&lang=scss&scoped=true&"
import style1 from "./UnassignedServiceRequest.vue?vue&type=style&index=1&id=d42b6ee2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42b6ee2",
  null
  
)

export default component.exports